/* SembraVero — theme.js : carrello AJAX Shopify + drawer + toast + animazioni */
(function () {
  "use strict";
  if (history.scrollRestoration) history.scrollRestoration = "manual";

  var R = window.SVroutes || { cart_add: "/cart/add.js", cart_change: "/cart/change.js", cart: "/cart.js", cart_page: "/cart" };
  var FREE = (window.SVfreeShip || 29.99) * 100; // in centesimi
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var euro = function (cents) { return "€" + (cents / 100).toFixed(2).replace(".", ","); };
  // Scaglioni sconto quantità (devono combaciare con gli Sconti automatici di Shopify)
  var TIERS = [{ q: 5, p: 25 }, { q: 3, p: 15 }, { q: 2, p: 8 }];
  function nextTier(q) { for (var i = TIERS.length - 1; i >= 0; i--) { if (q < TIERS[i].q) return TIERS[i]; } return null; }

  /* ---------------- CART ---------------- */
  var overlay, drawer, itemsEl, shipEl, upsellEl, footEl, toastEl, toastTimer;

  function cartBits() {
    overlay = $("#cartOverlay"); drawer = $("#cartDrawer");
    itemsEl = $("#cartItems"); shipEl = $("#cartShip"); upsellEl = $("#cartUpsell"); footEl = $("#cartFoot");
    toastEl = $("#cartToast");
  }
  function openCart() { if (!drawer) return; overlay.classList.remove("opacity-0", "pointer-events-none"); drawer.classList.remove("translate-x-full"); document.body.style.overflow = "hidden"; }
  function closeCart() { if (!drawer) return; overlay.classList.add("opacity-0", "pointer-events-none"); drawer.classList.add("translate-x-full"); document.body.style.overflow = ""; }
  function isOpen() { return drawer && !drawer.classList.contains("translate-x-full"); }

  function fetchCart() { return fetch(R.cart, { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }); }

  function addToCart(variantId, qty) {
    return fetch(R.cart_add, {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); });
  }
  function changeCart(key, qty) {
    return fetch(R.cart_change, {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }

  function updateCount(n) { document.querySelectorAll("#cartCount").forEach(function (b) { b.textContent = n; }); }

  function renderCart(cart) {
    if (!drawer) return;
    updateCount(cart.item_count);
    var s = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    var remain = Math.max(0, FREE - s), prog = Math.min(100, s / FREE * 100);
    var n = cart.item_count, nt = nextTier(n);
    var nudge = (cart.items.length && nt) ? '<div class="mt-3 text-xs text-silver bg-silver/10 border border-silver/25 rounded-lg px-3 py-2">Aggiungi ' + (nt.q - n) + ' tatuagg' + ((nt.q - n) === 1 ? "io" : "i") + ' e risparmia il ' + nt.p + '%</div>' : '';
    shipEl.innerHTML = (remain > 0
      ? '<p class="text-sm mb-2">Ti mancano <strong class="text-bone">' + euro(remain) + '</strong> alla <strong class="text-bone">spedizione gratis</strong></p>'
      : '<p class="text-sm mb-2 text-silver">✓ Spedizione gratis sbloccata</p>')
      + '<div class="h-1.5 rounded-full bg-ink3 overflow-hidden"><div class="h-full bg-silver transition-all duration-500" style="width:' + prog + '%"></div></div>' + nudge;

    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="text-bonedim text-sm text-center py-12">Il carrello è vuoto.<br>Aggiungi il tuo primo tatuaggio.</p>';
      upsellEl.innerHTML = "";
      footEl.innerHTML = '<a href="' + (window.SVroutes ? "/collections/all" : "#") + '" class="block text-center bg-silver hover:bg-silverhover text-ink py-4 rounded-full text-sm font-semibold uppercase tracking-wider">Esplora i tatuaggi</a>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (i) {
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") : "";
      return '<div class="flex gap-3">' +
        '<a href="' + i.url + '"><img src="' + img + '" alt="" class="w-16 h-20 object-cover rounded-lg border border-[var(--line)]" /></a>' +
        '<div class="flex-1 min-w-0"><a href="' + i.url + '" class="text-sm font-medium block truncate">' + i.product_title + '</a>' +
        (i.variant_title && i.variant_title !== "Default Title" ? '<p class="text-bonedim text-xs">' + i.variant_title + '</p>' : '') +
        '<p class="text-bonedim text-xs mt-0.5">' + euro(i.final_price) + '</p>' +
        '<div class="flex items-center gap-2 mt-2">' +
          '<button data-key="' + i.key + '" data-q="' + (i.quantity - 1) + '" class="cq w-6 h-6 grid place-items-center rounded-full border border-[var(--line)] hover:border-bone cursor-pointer">−</button>' +
          '<span class="text-sm w-5 text-center">' + i.quantity + '</span>' +
          '<button data-key="' + i.key + '" data-q="' + (i.quantity + 1) + '" class="cq w-6 h-6 grid place-items-center rounded-full border border-[var(--line)] hover:border-bone cursor-pointer">+</button>' +
          '<button data-key="' + i.key + '" data-q="0" class="cq ml-3 text-xs text-bonedim hover:text-bone underline cursor-pointer">Rimuovi</button>' +
        '</div></div>' +
        '<div class="text-sm whitespace-nowrap">' + euro(i.final_line_price) + '</div></div>';
    }).join("");

    var discHTML = "";
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      discHTML = cart.cart_level_discount_applications.map(function (d) {
        return '<div class="flex justify-between text-sm text-silver mb-1"><span>' + d.title + '</span><span>−' + euro(d.total_allocated_amount) + '</span></div>';
      }).join("");
    }
    footEl.innerHTML =
      '<div class="flex justify-between text-sm mb-1"><span class="text-bonedim">Subtotale</span><span>' + euro(cart.items_subtotal_price) + '</span></div>' +
      discHTML +
      '<div class="flex justify-between text-base font-semibold mb-3 pt-2 border-t border-[var(--line)]"><span>Totale</span><span>' + euro(cart.total_price) + '</span></div>' +
      '<a href="' + (R.cart_page || "/cart") + '" class="block text-center w-full bg-silver hover:bg-silverhover text-ink py-4 rounded-full text-sm font-semibold uppercase tracking-wider">Vai al carrello</a>' +
      '<p class="text-center text-bonedim text-xs mt-2">Sconti, spedizione e tasse calcolate alla cassa</p>';

    // upsell via product recommendations
    if (cart.items[0]) {
      var pid = cart.items[0].product_id;
      fetch("/recommendations/products.json?product_id=" + pid + "&limit=3&intent=related")
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var prods = (d.products || []).filter(function (p) { return p.available; }).slice(0, 3);
          if (!prods.length) { upsellEl.innerHTML = ""; return; }
          upsellEl.innerHTML = '<p class="text-xs uppercase tracking-[.16em] text-bonedim mb-3">Completa il look</p><div class="space-y-2.5">' + prods.map(function (p) {
            var v = (p.variants || []).filter(function (x) { return x.available; })[0];
            if (!v) return "";
            var img = (p.featured_image || (p.images && p.images[0]) || "");
            return '<div class="flex items-center gap-3"><img src="' + img + '" class="w-10 h-12 object-cover rounded border border-[var(--line)]" alt=""><a href="' + p.url + '" class="flex-1 text-sm truncate">' + p.title + '</a><span class="text-xs text-bonedim mr-1">' + euro(p.price) + '</span><button class="sv-add text-xs uppercase tracking-wider border border-silver/40 text-silver hover:bg-silver hover:text-ink rounded-full px-3 py-1.5 transition cursor-pointer" data-variant-id="' + v.id + '" data-title="' + p.title + '" data-img="' + img + '">Aggiungi</button></div>';
          }).join("") + '</div>';
        }).catch(function () { upsellEl.innerHTML = ""; });
    }
  }

  /* toast */
  function showToast(title, img) {
    if (!toastEl) return;
    toastEl.innerHTML =
      '<img src="' + (img || "") + '" class="w-12 h-14 object-cover rounded-lg border border-[var(--line)] shrink-0" alt="" />' +
      '<div class="flex-1 min-w-0"><p class="text-[11px] uppercase tracking-[.14em] text-silver flex items-center gap-1.5"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5" stroke-linecap="round" stroke-linejoin="round"/></svg>Aggiunto al carrello</p><p class="text-sm truncate mt-0.5">' + (title || "") + '</p></div>' +
      '<button class="toastCart text-[11px] uppercase tracking-wider border border-[var(--line)] hover:border-bone rounded-full px-3 py-2 whitespace-nowrap cursor-pointer">Vedi</button>';
    toastEl.classList.remove("-translate-y-8", "opacity-0", "pointer-events-none");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 2800);
  }
  function hideToast() { if (toastEl) toastEl.classList.add("-translate-y-8", "opacity-0", "pointer-events-none"); }

  function initCart() {
    cartBits();
    fetchCart().then(renderCart).catch(function () {});
    if (overlay) overlay.addEventListener("click", closeCart);
    var cc = $("#cartClose"); if (cc) cc.addEventListener("click", closeCart);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });
    document.addEventListener("click", function (e) {
      var add = e.target.closest && e.target.closest(".sv-add");
      if (add) {
        e.preventDefault();
        var vid = add.getAttribute("data-variant-id");
        if (!vid) return;
        addToCart(vid, 1).then(function () { return fetchCart(); }).then(function (cart) {
          renderCart(cart);
          if (isOpen()) {} else showToast(add.getAttribute("data-title"), add.getAttribute("data-img"));
        });
        return;
      }
      var cq = e.target.closest && e.target.closest(".cq");
      if (cq) { changeCart(cq.getAttribute("data-key"), parseInt(cq.getAttribute("data-q"), 10)); return; }
      var cb = e.target.closest && e.target.closest("#cartBtn");
      if (cb) { e.preventDefault(); openCart(); return; }
      var tc = e.target.closest && e.target.closest(".toastCart");
      if (tc) { hideToast(); openCart(); return; }
    });
  }

  /* ---------------- MENU / HEADER ---------------- */
  function initChrome() {
    var menuBtn = $("#menuBtn"), menu = $("#mobileMenu");
    if (menuBtn && menu) menuBtn.addEventListener("click", function () { menu.classList.toggle("hidden"); });
    if (menu) menu.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", function () { menu.classList.add("hidden"); }); });
    var header = $("#header");
    if (header) window.addEventListener("scroll", function () {
      if (window.scrollY > 20) header.classList.add("shadow-[0_10px_40px_rgba(0,0,0,.4)]");
      else header.classList.remove("shadow-[0_10px_40px_rgba(0,0,0,.4)]");
    }, { passive: true });
  }

  /* ---------------- MOTION ---------------- */
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var io;
  function wrapClips() {
    document.querySelectorAll(".reveal.clip").forEach(function (el) {
      if (el.querySelector(":scope > .ci")) return;
      var s = document.createElement("span"); s.className = "ci";
      if (el.style.transitionDelay) s.style.transitionDelay = el.style.transitionDelay;
      while (el.firstChild) s.appendChild(el.firstChild);
      el.appendChild(s);
    });
  }
  function observeReveals() { document.querySelectorAll(".reveal:not(.in)").forEach(function (n) { io.observe(n); }); }
  function initMotion() {
    io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } }); }, { threshold: 0.12 });
    wrapClips(); observeReveals();
    if (!reduce && !("ontouchstart" in window)) {
      document.querySelectorAll(".magnetic").forEach(function (btn) {
        btn.addEventListener("pointermove", function (e) { var r = btn.getBoundingClientRect(); btn.style.transform = "translate(" + ((e.clientX - (r.left + r.width / 2)) * 0.22).toFixed(1) + "px," + ((e.clientY - (r.top + r.height / 2)) * 0.34).toFixed(1) + "px)"; });
        btn.addEventListener("pointerleave", function () { btn.style.transform = ""; });
      });
    }
    var pEls = Array.prototype.slice.call(document.querySelectorAll("[data-parallax]"));
    function parallax() { var vh = window.innerHeight; for (var i = 0; i < pEls.length; i++) { var el = pEls[i], r = el.getBoundingClientRect(); if (r.bottom < -240 || r.top > vh + 240) continue; var prog = ((r.top + r.height / 2) - vh / 2) / (vh / 2); var amt = parseFloat(el.getAttribute("data-parallax")) || 0; el.style.setProperty("--pl", (-prog * amt).toFixed(1) + "px"); } }
    var ticking = false;
    function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(function () { parallax(); ticking = false; }); }
    if (!reduce) { window.addEventListener("scroll", onScroll, { passive: true }); window.addEventListener("resize", onScroll, { passive: true }); }
    parallax();
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener("click", function (e) { var id = a.getAttribute("href"); if (!id || id.length < 2) return; var t = document.querySelector(id); if (!t) return; e.preventDefault(); t.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" }); });
    });
  }

  /* count-up */
  function initCounters() {
    var els = document.querySelectorAll("[data-count]"); if (!els.length) return;
    function fmt(v, dec, dot) { var s = dec ? v.toFixed(1).replace(".", ",") : String(Math.round(v)); if (dot && !dec) s = Math.round(v).toLocaleString("it-IT"); return s; }
    function run(el) {
      var raw = el.getAttribute("data-count"), target = parseFloat(raw.replace(",", ".")), dec = raw.indexOf(",") > -1 ? 1 : 0, dot = el.getAttribute("data-dot") === "1", suf = el.getAttribute("data-suffix") || "";
      if (reduce) { el.textContent = fmt(target, dec, dot) + suf; return; }
      var start = null;
      function step(t) { if (start === null) start = t; var p = Math.min(1, (t - start) / 1300), e = 1 - Math.pow(1 - p, 3); el.textContent = fmt(target * e, dec, dot) + suf; if (p < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    }
    var o = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { run(e.target); o.unobserve(e.target); } }); }, { threshold: 0.6 });
    els.forEach(function (el) { o.observe(el); });
  }

  /* FAQ accordion (delegato) */
  function initFaq() {
    document.querySelectorAll(".faq-item").forEach(function (item) {
      var btn = item.querySelector(".faq-q"), body = item.querySelector(".acc-body"), ic = item.querySelector(".faq-ic");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var open = body.style.maxHeight && body.style.maxHeight !== "0px";
        document.querySelectorAll(".acc-body").forEach(function (b) { b.style.maxHeight = "0px"; });
        document.querySelectorAll(".faq-ic").forEach(function (s) { s.style.transform = "none"; });
        if (!open) { body.style.maxHeight = body.scrollHeight + "px"; if (ic) ic.style.transform = "rotate(45deg)"; }
      });
    });
  }

  /* before/after slider */
  function initBA() {
    var ba = $("#ba"); if (!ba) return;
    var dragging = false;
    function setPos(x) { var r = ba.getBoundingClientRect(); var p = Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100)); ba.style.setProperty("--pos", p + "%"); }
    ba.addEventListener("pointerdown", function (e) { dragging = true; ba.setPointerCapture(e.pointerId); setPos(e.clientX); });
    ba.addEventListener("pointermove", function (e) { if (dragging) setPos(e.clientX); });
    window.addEventListener("pointerup", function () { dragging = false; });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initCart(); initChrome(); initMotion(); initCounters(); initFaq(); initBA();
  });
})();
